import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Form, Button } from 'react-bootstrap';
import IconPicker from '../../components/IconPicker';
import { Editor } from "react-draft-wysiwyg";
import { EditorState, convertToRaw } from 'draft-js';

export default function InfoNew() {
	const navigation = useNavigate();

	const [title, setTitle] = useState("");
	const [pageType, setPageType] = useState("text");
	const [content, setContent] = useState<any>();
	const [icon, setIcon] = useState("");
	const iconName = icon.substring(1).replace(/([A-Z])/, v => v.toLocaleLowerCase()).replaceAll(/([A-Z])/g, v => `-${v.toLowerCase()}`).substring(1);

	function formSubmit(e: React.FormEvent<HTMLFormElement>) {
		e.preventDefault();
		onSubmit();
	}

	async function onSubmit() {
		const json = {
			title,
			pageType,
			content,
			icon: iconName,
		};
		const res = await fetch(`${process.env.REACT_APP_API_URL}/info`, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(json),
		});
		const data = await res.json();
		console.log(data);

		if (res.ok) {
			navigation('/info');
		}
	}

	return (
		<div className="InfoNew">
			<div className='container container-lg'>
				<Form onSubmit={formSubmit}>
					<Form.Group controlId="title" className="mb-3">
						<Form.Label>Title</Form.Label>
						<Form.Control type="text" placeholder="Enter title" value={title} onChange={e => setTitle(e.target.value)} />
					</Form.Group>
					<Form.Group controlId="icon" className="mb-3">
						<Form.Label>Icon</Form.Label>
						{ /* @ts-ignore */}
						<IconPicker
							value={icon}
							onChange={(v: string) => setIcon(v)}
						/>
					</Form.Group>
					<Form.Group controlId="pageType" className="mb-3">
						<Form.Label>Page Type</Form.Label>
						<Form.Select value={pageType} onChange={e => setPageType(e.target.value)}>
							<option value="text">Text</option>
							<option value="link">Link</option>
						</Form.Select>
					</Form.Group>
					{pageType === "text" && <TextContent content={content} setContent={setContent} />}
					{pageType === "link" && <LinkContent content={content} setContent={setContent} />}
					<Button variant="primary" type="submit">
						Create
					</Button>
				</Form>
			</div>
		</div>
	);
}

function TextContent({ content, setContent }: { content: any, setContent: (content: any) => void }) {

	const [editorState, setEditorState] = useState<EditorState>(EditorState.createEmpty());

	function onEditorStateChange(editorState: EditorState) {
		setEditorState(editorState);
		setContent(convertToRaw(editorState.getCurrentContent()));
	}

	return (
		<Form.Group controlId="content" className="mb-3">
			<Form.Label>Content</Form.Label>
			<Form.Control as={Editor}
				editorState={editorState}
				toolbarClassName="toolbarClassName"
				wrapperClassName="wrapperClassName"
				editorClassName="editorClassName"
				onEditorStateChange={onEditorStateChange}
				wrapperStyle={{ border: "1px solid black", borderRadius: 5, padding: "5px" }}
			/>
		</Form.Group>
	);
}

function LinkContent({ content, setContent }: { content: { href: string }, setContent: (content: { href: string }) => void }) {
	return (
		<Form.Group controlId="content" className="mb-3">
			<Form.Label>Link</Form.Label>
			<Form.Control type="text" placeholder="Enter Link" value={content?.href} onChange={e => setContent({ href: e.target.value })} />
		</Form.Group>
	);
}
